import api from "../index";
import { qs } from "../../utils/utils.js";

export const UploadDocumentApi = (data, headers) => api.post('fileupload/upload-kyc-document', data, headers);
export const CheckKycStatusApi = (params) => api.get(`usermaster/get-kyc-status?${qs(params)}`);